import React from 'react';
import {useTranslation} from "react-i18next";
import Modal from "../../../components/modal/modal.component";
import {StyledButton, StyledWiteButton} from "@components/button/button.style";
import {StyledFooter} from "@components/pane/pane.style";
import {StyledModalContent} from "@components/modal/modal.style";
import {StyledDataTable} from "@components/content/content.style";
import moment from "moment";
import {Proposal} from "@models/calendar";
import {acceptProposal} from "@services/calendar/proposal.service";
import {useToast} from "@context/toast.context";
import {rejectProposal} from "@services/timetable.service";

type EventPreviewModalProps = {
    proposal: Proposal;
    isOpen: boolean;
    onDone: () => void,
    onClose: () => void;
};

const EventPreviewModal: React.FC<EventPreviewModalProps> = ({isOpen, proposal, onClose, onDone}: EventPreviewModalProps) => {
    const {t} = useTranslation();
    const {showToast} = useToast();

    const handleProposalAccept = async () => {
        try {
            await acceptProposal(proposal.id);
            onClose();
            onDone();
        } catch (error) {
            let message = 'proposal.error.accept';

            if (error.response.data.message === 'PROPOSAL_HAS_ALREADY_STARTED') {
                message = 'proposal.error.hasAlreadyStarted';
            }

            showToast({
                message: t(message),
                type: 'danger',
                duration: 3000,
            });

            console.error(error);
        }
    }

    const handleProposalReject = async () => {
        try {
            await rejectProposal(proposal.id);
            onClose();
            onDone();
        } catch (error) {
            let message = 'proposal.error.reject';

            if (error.response.data.message === 'PROPOSAL_HAS_ALREADY_STARTED') {
                message = 'proposal.error.hasAlreadyStarted';
            }

            showToast({
                message: t(message),
                type: 'danger',
                duration: 3000,
            });

            console.error(error);
        }
    }

    return (
        <Modal initialBreakpoint={0.6} breakpoints={[0, 0.6]} isOpen={isOpen} onDidDismiss={() => onClose()}>
            <StyledModalContent className="scrollable">
                <h6 className="description">{t('notificationTab.timetablePane.preview.title', {coordinator: proposal.attributes.coordinator})}</h6>
                <StyledDataTable>
                    <div className="data-row">
                        <div className="data-title">{t('notificationTab.timetablePane.preview.place')}</div>
                        <div className="data-value">{proposal.attributes.placeOfService || '--'}</div>
                        <div className="data-action"></div>
                    </div>
                    <div className="data-row">
                        <div className="data-title">{t('notificationTab.timetablePane.preview.jobPosition')}</div>
                        <div className="data-value long-text">{proposal.attributes.jobPosition || '--'}</div>
                        <div className="data-action"></div>
                    </div>
                    <div className="data-row">
                        <div className="data-title">{t('notificationTab.timetablePane.preview.from')}</div>
                        <div
                            className="data-value">{moment(proposal.attributes.originalStartTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm')}</div>
                        <div className="data-action"></div>
                    </div>
                    <div className="data-row">
                        <div className="data-title">{t('notificationTab.timetablePane.preview.to')}</div>
                        <div
                            className="data-value">{moment(proposal.attributes.originalEndTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm')}</div>
                        <div className="data-action"></div>
                    </div>
                    <div className="data-row">
                        <div className="data-title">{t('notificationTab.timetablePane.preview.details')}</div>
                        <div className="data-value">{proposal.attributes.description || '--'}</div>
                        <div className="data-action"></div>
                    </div>
                </StyledDataTable>
            </StyledModalContent>
        </Modal>
    );
};

export default EventPreviewModal;
